export default function (/**@type {ApisauceInstance} */ api) {
  const getProductSkus = (paging) => api.get(`ProductForSku`, paging);
  const getAllProductSkus = (paging) => api.get(`ProductForSku/search-dashboard`, paging);
  const createProductSku = (payload) =>
    api.post(`ProductForSku/create`, payload);
  const editProductSku = ({ id, payload }) =>
    api.put(`ProductForSku/edit`, payload);
  const deleteProductSku = (id) => api.delete(`ProductForSku/remove/${id}`);

  return {
    ProductSkus: {
      getAllProductSkus,
      getProductSkus,
      createProductSku,
      editProductSku,
      deleteProductSku,
    },
  };
}
